import React from "react";

import classnames from "classnames";
import { findIndex } from "lodash";
import AnalyticsTracking from "Utils/AnalyticsTracking";

import { RoutedBackButton } from "Common/forms/buttons";
import { Table } from "Common/Table";

import ChooseCoverageModal from "./Components/ChooseCoverageModal";
import MultipleDentalPlans from "./Components/MultipleDentalPlans";
import MultipleMedicalPlans from "./Components/MultipleMedicalPlans";
import MultiplePlanHeader from "./Components/MultiplePlanHeader";
import MultipleVisionPlans from "./Components/MultipleVisionPlans";

import type { FamilyInfo } from "./Utils/chooseCoverage";
import type { ContributionFormula, FamilyQuote, PlanPrice } from "Utils/types";

import makeBem from "Utils/makeBem";

const bem = makeBem("EmployeeMultiplePlans");

type Props = {
  plans: Array<PlanPrice>;
  prices: Array<FamilyQuote>;
  contributions: ContributionFormula;
  familyInfo: Array<FamilyInfo>;
  backLink?: string;
  readonly onClickBack?: () => void;
};

type State = {
  shownIndex: number | null | undefined;
};

export default class EmployeeMultiplePlans extends React.Component<Props, State> {
  state = {
    shownIndex: null,
  };

  openModal = (planId: string) => {
    AnalyticsTracking.trackEvent("cta_clicked", {
      location: "employee_application_choose_coverage_page",
      label: "open_enroll_or_decline_modal",
    });

    this.setState({ shownIndex: findIndex(this.props.plans, { id: planId }) });
  };

  closeModal = () => {
    AnalyticsTracking.trackEvent("cta_clicked", {
      location: "employee_application_choose_coverage_page",
      label: "close_enroll_or_decline_modal",
    });

    this.setState({ shownIndex: null });
  };

  render() {
    const planType = this.props.plans[0].type;
    return (
      <div style={{ overflow: "scroll" }}>
        <Table className={classnames(bem())} borders="none">
          <MultiplePlanHeader onClick={this.openModal} plans={this.props.plans} />

          {planType === "medical" && (
            <MultipleMedicalPlans
              plans={this.props.plans}
              prices={this.props.prices}
              contributions={this.props.contributions}
              familyInfo={this.props.familyInfo}
              onClick={this.openModal}
            />
          )}
          {planType === "dental" && (
            <MultipleDentalPlans
              plans={this.props.plans}
              prices={this.props.prices}
              contributions={this.props.contributions}
              familyInfo={this.props.familyInfo}
              onClick={this.openModal}
            />
          )}
          {planType === "vision" && (
            <MultipleVisionPlans
              plans={this.props.plans}
              prices={this.props.prices}
              contributions={this.props.contributions}
              familyInfo={this.props.familyInfo}
              onClick={this.openModal}
            />
          )}
        </Table>
        <div>
          <RoutedBackButton href={this.props.backLink} onClick={this.props.onClickBack} />
        </div>
        <ChooseCoverageModal
          plan={this.props.plans[this.state.shownIndex || 0]}
          prices={this.props.prices}
          contributions={this.props.contributions}
          familyInfo={this.props.familyInfo}
          openModal={this.state.shownIndex !== null}
          closeModal={this.closeModal}
        />
      </div>
    );
  }
}
